import { createFileRoute, Outlet } from '@tanstack/react-router';
import Footer from '@/components/Footer';
import Navbar from '@/components/Navbar';

export const Route = createFileRoute('/legal')({
  component: LegalLayout,
});

function LegalLayout() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main className="pt-32 pb-16 px-6">
        <div className="max-w-3xl mx-auto legal-content text-gray-300 [&_h1]:text-4xl [&_h1]:font-bold [&_h1]:text-white [&_h1]:mb-6 [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-4 [&_p]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_li]:mb-1 [&_strong]:text-white [&_a]:text-purple-400 [&_a:hover]:text-purple-300">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
